// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { dashboardBuilderLegend16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-dashboard-builder-legend': IconDashboardBuilderLegend;
    }
}

/**
 * The icon component for the 'dashboardBuilderLegend' icon
 */
export class IconDashboardBuilderLegend extends Icon {
    public constructor() {
        super(dashboardBuilderLegend16X16);
    }
}

registerIcon('icon-dashboard-builder-legend', IconDashboardBuilderLegend);
export const iconDashboardBuilderLegendTag = 'nimble-icon-dashboard-builder-legend';
